const WHATSAPP_NUMBER = "5521988619303";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  default:
    "Olá, Darlei! Vi seu site e gostaria de consultar disponibilidade para uma experiência no Rio.",
  sugestao:
    "Olá, Darlei! Gostaria de sugerir um lugar que não encontrei no catálogo: ________. Podemos avaliar a possibilidade de incluí-lo em um roteiro?",
  cristo:
    "Olá, Darlei! Vi seu site e tenho interesse no passeio Cristo Redentor. Gostaria de consultar disponibilidade, valores e detalhes.",
  paoDeAcucar:
    "Olá, Darlei! Vi seu site e tenho interesse no passeio Pão de Açúcar. Gostaria de consultar disponibilidade, valores e detalhes.",
  custom:
    "Olá, Darlei! Vi seu site e gostaria de montar um roteiro personalizado pelo Rio de Janeiro.",
};

export const trackWhatsApp = (location, tour = "geral") => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "whatsapp_click", {
    event_category: "contato",
    button_location: location,
    tour_name: tour,
    event_label: `${location} | ${tour}`,
  });
};

export const tourMessage = (tourName) =>
  `Olá, Darlei! Vi seu site e tenho interesse no passeio ${tourName}. Gostaria de consultar disponibilidade, valores e detalhes.`;
